// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '바스칸바이오제약',
  targetSheetName: '수수료 변경안 (EDI)',
  headerRowIndex: 1,
  headerRowCount: 1,
  dataStartRowIndex: 2,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '보험약가',
  },
  requiredHeaders: [
    'NO',
    '제품명',
    '대조약',
    '성분',
    '구분',
    '보험코드',
    '보험약가',
    '%',
  ],
});
